import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthenticationService } from 'src/app/front-user/shared/services/authentication.service';
import { User } from 'src/app/front-user/shared/models/user.model';
import { EtenderService } from 'src/app/shared/services/etender.service';
import { AlertService } from 'src/app/shared/components/alert/alert.service';
import { TranslateService } from '@ngx-translate/core';
import { ETendersAttachmentDTO, ETenderAttachmentType, ETenderDTO } from 'src/app/shared/models/e-tender.model';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { fileService } from 'src/app/front-user/shared/services/file.service';
import { HttpEventType, HttpResponse } from '@angular/common/http';
import { Languages } from 'src/app/shared/models/enums.model';
import { GlobalServices } from 'src/app/shared/services/global.service';
import { AppConfig } from 'src/app/shared/services/app.config';

@Component({
  selector: 'app-cancel-tender',
  templateUrl: './cancel-tender.component.html',
  styles: []
})
export class CancelTenderComponent implements OnInit {
  tenderId: string;
  user: User = new User();
  showRequest = true;
  AttachmentProgress: number;
  @ViewChild('createTender',{static: false}) createTender: ElementRef;
  cancelTenderForm: FormGroup;
  CancelTenderAttachments: ETendersAttachmentDTO[] = [];
  submitted = false;
  model: ETenderDTO;
  displayedLang: string;
  constructor(private route: ActivatedRoute, private alertService: AlertService,
    private translate: TranslateService, private etenderSrv: EtenderService,
    private formBuilder: FormBuilder, private fileService: fileService,
    private globalSrv: GlobalServices) {
    if (history.state.data && history.state.data.tenderId) {
      this.tenderId = history.state.data.tenderId;
    } else {
      window.history.back();
    }
    this.displayedLang = this.globalSrv.getLanguage() == Languages.Arabic ? 'NameAR' : 'NameEN';
  }

  ngOnInit() {
    this.buildForm();
  }
  buildForm() {
    this.cancelTenderForm = this.formBuilder.group({
      Id: [''],
      CancellationAttachments: [''],
      CancellationReason: [null, [Validators.required]],
    });
  }
  get ETenderAttachmentType() {
    return ETenderAttachmentType;
  }
  get Validate() {
    return this.cancelTenderForm.controls;
  }
  AddAttachmentFile(event, currFormControl, docName, attachmentType: ETenderAttachmentType, progressVariableName) {
    if (!this.fileService.IsFileExtentionValid(event)) {
      currFormControl.setValue('');
      this.translate.get('FRONT_USER.NotAllowedFileExtentionMessage').subscribe((res: string) => {
        alert(res);
        return false;
      });
    }

    if (!this.fileService.IsFileSizeValid(event)) {
      currFormControl.setValue('');
      this.translate.get('FRONT_USER.NotAllowedFileSize').subscribe((res: string) => {
        alert(res);
        return false;
      });

    }

    const file = event.target.files[0];
    const formData = new FormData();
    formData.append('File', file);
    formData.append('DocumentName', docName);
    formData.append('FolderName', AppConfig.settings.apiServer.ETenderUploadsFolder);
    this.fileService.fileUploaderForAdmin(formData).subscribe(
      event => {

        if (event.type === HttpEventType.UploadProgress) {
          // This is an upload progress event. Compute and show the % done:
          const percentDone = Math.round(100 * event.loaded / event.total);
          // console.log(`File is ${percentDone}% uploaded.`);
          this[progressVariableName] = percentDone;
          currFormControl.setErrors({ invalid: true });
        } else if (event instanceof HttpResponse) {
          const jsonResponse = event.body.Data;
          const Url = jsonResponse.Url;
          const attachment = new ETendersAttachmentDTO();
          attachment.URL = Url;
          attachment.DocumentName = docName;
          attachment.AttachmentTypeId = attachmentType;
          this.CancelTenderAttachments = this.CancelTenderAttachments.filter(h => h.AttachmentType !== attachmentType);
          this.CancelTenderAttachments.push(attachment);
          currFormControl.setErrors(null);
        }
      }
    );

  }
  onSubmit() {
    this.submitted = true;
    if (!this.cancelTenderForm.invalid) {
      this.model = this.cancelTenderForm.getRawValue();
      this.model.ETendersAttachments = this.CancelTenderAttachments;
      this.model.Id = this.tenderId;
      this.globalSrv.isLoaderEnabled = true;
      this.etenderSrv.CancelTender(this.model).subscribe(d => {
        if (d.Success) {
          this.showRequest = false;
        } else {
          this.showRequest = true;
          this.alertService.error(d.ErrorMessages[0]);
        }
        this.globalSrv.isLoaderEnabled = false;

      });
    }
  }
}
